import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Globals } from '../../globals';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ApiService {

    constructor(private http: Http, private globals: Globals) {

    }

    public getLanguage(): Observable<any> {

        return this.http.get(this.globals.BASE_API_URL + 'api/language/').map(res => res.json());
    }
    public getListSlide(type): Observable<any> {

        return this.http.get(this.globals.BASE_API_URL + 'api/getListSlide/' + type).map(res => res.json());
    }
    public getmenu(postion): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL + 'api/menu/' + postion).map(res => res.json());
    }
    public getListContentHome(): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL + 'api/getlistHomecontent').map(res => res.json());
    }
    public applicationProduct(link): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL + 'api/applicationProduct/' + link).map(res => res.json());
    }
    //api/getpages/(:num)
    public application($option: number): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL + 'api/getpages/' + $option).map(res => res.json());
    }
    //$route['api/getlistGroupProducts']
    //api/getlistcontentByGroup/(:num)
    public getlistByGroupContent($option: any): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL + 'api/getlistcontentByGroup/' + $option).map(res => res.json());
    }
    //product type api/getlistproductOtion/
    public title(): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL + 'api/title/').map(res => res.json());
    }
    //api/productcatalogry/

    public listcontent(): Observable<any> {

        return this.http.get(this.globals.BASE_API_URL + 'api/getlistcontent').map(res => res.json());
    }
    public getLibrary(): Observable<any> {

        return this.http.get(this.globals.BASE_API_URL + 'api/getLibrary').map(res => res.json());
    }
    public getLibraryVideoHome(): Observable<any> {

        return this.http.get(this.globals.BASE_API_URL + 'api/getLibraryVideoHome').map(res => res.json());
    }
    public getLibraryImgHome(): Observable<any> {

        return this.http.get(this.globals.BASE_API_URL + 'api/getLibraryImgHome').map(res => res.json());
    }
    public admiLogin(data): Observable<any> {
        return this.http.post(this.globals.BASE_API_URL + 'api/admin/login', data).map(res => res.json());
    }
    //pages api/getPage/
    public page(option): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL + 'api/getPage/' + option).map(res => res.json());
    }
    //pagelink
    public getProductLink(link): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL + 'api/getProductLink/' + link).map(res => res.json());
    }
    public getListContentDetail(url): Observable<any> {

        return this.http.get(this.globals.BASE_API_URL + 'api/getcontentdetail/' + url).map(res => res.json());
    }
    public getlistHomecontent(): Observable<any> {

        return this.http.get(this.globals.BASE_API_URL + 'api/getlistHomecontent').map(res => res.json());
    }
    //update views
    public views(link): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL + 'api/updateViews/' + link).map(res => res.json());
    }
    //addContact
    public addContact(data): Observable<any> {
        return this.http.post(this.globals.BASE_API_URL + 'api/addContact/', data).map(res => res.json());
    }
    //api/resultsNew
    public results(lotdate: any = ""): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL + 'api/results/' + lotdate).map(res => res.json());
    }
    //api api/addFaq
    public faq(): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL + 'api/getlistFaqHome').map(res => res.json());
    }
    public addFaq(data): Observable<any> {
        return this.http.post(this.globals.BASE_API_URL + 'api/addFaq', data).map(res => res.json());
    }
    public getLibraryVideo(): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL + 'api/getLibraryVideo').map(res => res.json());
    }
    public getvideo2(): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL + 'api/getvideo2').map(res => res.json());
    }
    public getResultByDate(date: string): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL_XOSOTUCHON + 'api?drawDate=' + date).map(res => res.json());
    }
    public checkTicketResult(date: string, prizeNumber : string, keySearch : string): Observable<any> {
        return this.http.get(this.globals.BASE_API_URL_XOSOTUCHON + 'api/search?drawDate=' + date+"&prizeNumber="+ prizeNumber + "&keySearch="+keySearch).map(res => res.json());
    }
}



// WEBPACK FOOTER //
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/app/services/api/api.service.ts